export const access_specifier = {
    "1"  : 'Fe',
    "2" : 'Unlimited',
    "3" : 'Agency Theme',
    "4" : 'Masterclass',
    "5" : "Super Admin",
    "6" : 'Agency 5 licenses',
    "61" : 'Agency 10 licenses',
    "62" : 'Agency 20 licenses',
    "9" : 'Bundle Offer', //10 licenses + masterclass + agency theme + Unlimited access
}
